export const blockIconsSocialSentimentVerySatisfied = (
	<span className='material-symbols-outlined'>sentiment_very_satisfied</span>
);
